<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <!-- Page Heading -->
    <h2 class="h3 mb-4 text-gray-800">{{ languages[lang].lessons }}</h2>

    <div class="row" v-if="lessons != null && lessons.length > 0">
      <div
        class="col-xl-3 col-lg-4 col-sm-12 mb-4"
        v-for="(lesson, index) in lessons"

      >
        <div class="card h-100 mycard">
          <!-- <img class="card-img-top  embed-responsive" v-if="lesson.images==null || (lesson.images!=null && lesson.images.length==0)" v-bind:src="'/assets/img/defaultlesson.png'" > -->
          <!-- <img class="card-img-top embed-responsive" v-else v-bind:src="lesson.images[0].fileUrl" > -->
          <div class="card-body" v-bind:style="_getColor(lesson)">
            <h5 class="card-title" v-bind:style="_getTextColor(lesson)">
              {{ lesson.name }}
            </h5>
            <!-- <span class="card-text" style="font-size:10pt" v-bind:style="_getTextColor(lesson)" >
                  <span v-if="lesson.description!=null && lesson.description.length>100">{{lesson.description.substring(0,100)}}..</span>
                  <span v-else>{{lesson.description}}</span>
                </span> -->

            <div
              v-if="lesson.zar"
              style="
                background: red;
                color: white;
                padding-top: 10px;
                padding-bottom: 4px;
              "
              class="text-center"
            >
              <p class="font-weight-bold">
                {{ lesson.zar.title }}
              </p>

              <p>{{ lesson.zar.description }}</p>
            </div>
          </div>
          <div class="card-footer text-muted">
            <div class="d-flex justify-content-between">
              <button         @click="goDetail(lesson)" class="card-link btn btn-sm btn-primary">
                {{ languages[lang].watch }}
              </button>
              <button v-if="lesson.id=='BEn03rZWWFh4k8dAr9KB'" class="card-link btn btn-sm btn-danger" @click="_takeExam(lesson.exams[0])">
                Шалгалт өгөx
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="loading == false" class="text-center alert alert-info">
      {{ languages[lang].lessonempty }}
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import lang from "./lang.js";
export default {
  name: "LessonGrid",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending: {
        content: [],
      },
      loading: false,
    };
  },
  mixins: [lang],
  created() {
    this._getLessons();
  },
  computed: {
    ...mapState(["currentUser", "lang"]),
  },
  methods: {
    _takeExam(exam) {
      console.log(exam)
      this.$router.push({
        name: "XShalgaltAnswering",
        params: {
          item: exam,
          showScores:false
        },
      });

      // fb.db
      //   .doc('lessons/' + )
      //   .get()
      //   .then(async (doc) => {
      //     if (doc.exists) {
      //       let asuulga = doc.data();
      //       asuulga.ref = doc.ref;
      //       asuulga.id = doc.id;
      //       this.$router.push({
      //       name: "XShalgaltAnswering",
      //       params: {
      //         item: asuulga,
      //         showScores:true
      //       },
      //     });


      //     } else {
            
      //     }
      //   })
      //   .catch(function (error) {
      //     console.log("Error getting document:", error);
      //   });

         

    },
    _getColor(lesson) {
      var colorText = "";
      if (lesson.bgColor == undefined) {
        colorText = colorText + "background-color:#fff;";
      } else {
        colorText = colorText + "background-color:" + lesson.bgColor;
      }
      return colorText;
    },
    _getTextColor(lesson) {
      var colorText = "";

      if (lesson.foreColor == undefined) {
        colorText = colorText + "color:#4e73df;";
      } else {
        colorText = colorText + "color:" + lesson.foreColor;
      }
      return colorText;
    },
    _getLessons() {
      var _this = this;
      var vm = this;
      if (this.currentUser != null) {
        //  fb.db.collection("lessons").limit(100).get().then(querySnapshot=>{
        //     this.lessons = [];
        //             querySnapshot.forEach(function(lessonDoc) {

        //                   let lesson=lessonDoc.data();
        //                   lesson.id=lessonDoc.id;
        //                   // if(lesson.published==true)
        //                     _this.lessons.push(lesson);
        //                   _this.loading=false;

        //             });
        //  });
        var _this = this;
        fb.usersCollection
          .doc(this.currentUser.uid)
          .get()
          .then((userData) => {
            this.loading = true;
            if (
              userData != null &&
              userData.exists &&
              userData.data().role != null &&
              userData.data().role == "student" &&
              userData.data().customer != null
            ) {
              userData
                .data()
                .customer.get()
                .then((stData) => {
                  if (stData != null && stData.exists) {
                    stData.ref
                      .collection("lessonList")
                      .orderBy("addedDate")
                      .onSnapshot((querySnapshot) => {
                        this.lessons = [];
                        if (querySnapshot.empty) {
                          _this.loading = false;
                        } else
                          querySnapshot.forEach(function (doc) {
                            if (doc.exists && doc.data().lessonRef != null) {
                              doc
                                .data()
                                .lessonRef.get()
                                .then((lessonDoc) => {
                                  let lesson = lessonDoc.data();
                                  lesson.id = lessonDoc.id;
                                  // if(lesson.published==true)

                                  fb.db
                                    .collection(
                                      "lessons/" + lesson.id + "/exams"
                                    )
                                    .get()
                                    .then((exam) => {
                                      lesson.exams = [];
                                      exam.forEach((xdoc) => {
                                        if (xdoc.data().published) {
                                          let ex = xdoc.data();
                                          ex.id = xdoc.id;
                                          ex.ref = xdoc.ref;
                                          console.log(ex.ref.path);
                                          lesson.exams.push(ex);
                                        }
                                      });
                                    });
                                  _this.lessons.push(lesson);

                                  _this.loading = false;
                                });
                            }
                          });
                      });
                  }
                });
              this.loading = false;
            } else this.loading = false;
          });
      }
    },

    goDetail(lesson) {
      this.$router.push({
        name: "LessonDetailPublic",
        params: { lessonId: lesson.id },
      });
    },
  },
};
</script>
<style>
.card-img-top {
  object-fit: cover !important;
  /* max-height: 165px!important; */
}
</style>